import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { metodoPrograma } from '../../components/api'
import Programa from '../../components/Programa/Programa'
import DateField from '../../components/DateField/DateField'
import dayjs from 'dayjs'
import { setError, setSuccess, setWarning } from '../../components/alerts'
import { useNavigate } from 'react-router-dom'

const retornaUsuario = (u = {}) => ({
  idUsuario: u?.idUsuario || undefined,
  dsEmail: u?.dsEmail || undefined,
  dsNome: u?.dsNome || undefined,
  nrDocumento: u?.nrDocumento || undefined,
  dtNascimento: u?.dtNascimento ? dayjs(u.dtNascimento, 'DD/MM/YYYY') : null,
  dtInclusao: u?.dtInclusao || undefined,
  dsPin: undefined,
  dsSenha: undefined,
  dsSenhaConfirmacao: undefined,
})

const UsuarioSenha = () => {
  const [usuarioAberto, setUsuarioAberto] = useState(null)
  const navigate = useNavigate()

  const buscaDadosUsuario = useCallback(async () => {
    const res = await metodoPrograma('getDadosUsuario', {})
    if (res.status) {
      setUsuarioAberto(res)
    }
  }, [])

  useEffect(() => {
    buscaDadosUsuario()
  }, [buscaDadosUsuario])

  const { control, register, handleSubmit, reset } = useForm()

  useEffect(() => {
    if (usuarioAberto) {
      reset(retornaUsuario(usuarioAberto))
    }
  }, [usuarioAberto, reset])

  const voltar = async () => {
    navigate(-1)
  }

  const salva = async (values) => {
    if (values.dsSenha !== values.dsSenhaConfirmacao) {
      setWarning('As senhas não conferem')
      return
    }
    const dados = {
      ...values,
      dtNascimento: values?.dtNascimento
        ? values.dtNascimento.format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }
    const res = await metodoPrograma('salva', dados)
    if (res.status) {
      setSuccess('Cadastro alterado')
      navigate(-1)
    } else setError(res.dsErro)
  }
  return (
    <Programa codigo="UsuarioControleDadosPessoais" habTrocaLocal={false}>
      <form onSubmit={handleSubmit(salva)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextField
              {...register('dsNome')}
              name="dsNome"
              label="Nome"
              fullWidth
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextField
              {...register('dsEmail')}
              name="dsEmail"
              label="Email"
              fullWidth
              disabled
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              {...register('dtInclusao')}
              name="dtInclusao"
              label="Inclusão"
              disabled
              fullWidth
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Controller
              name="dtNascimento"
              control={control}
              render={({ field, fieldState }) => (
                <DateField
                  {...field}
                  label="Data de Nascimento"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={field.value || null}
                  onChange={(v) => field.onChange(v)}
                  slotProps={{
                    textField: {
                      error: Boolean(fieldState.error),
                      helperText: fieldState.error?.message,
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              {...register('nrDocumento')}
              name="nrDocumento"
              label="Documento (CPF, CNH ou RG)"
              fullWidth
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              {...register('dsPin')}
              type="password"
              name="dsPin"
              label="PIN"
              fullWidth
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 6 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              {...register('dsSenha')}
              type="password"
              name="dsSenha"
              label="Senha"
              fullWidth
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <TextField
              {...register('dsSenhaConfirmacao')}
              type="password"
              name="dsSenhaConfirmacao"
              label="Confirmação de senha"
              fullWidth
              margin="dense"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ display: 'flex', flexDirection: 'row-reverse' }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ margin: '5px' }}
            >
              Salvar
            </Button>
            <Button
              onClick={voltar}
              variant="contained"
              color="secondary"
              style={{ margin: '5px' }}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Programa>
  )
}

export default memo(UsuarioSenha, isEqual)
